export default __webpack_public_path__ + "static/coffee1-205ea1624c21f70f4b8bc7906a4407dc.png";